import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

function AppLayout() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <AppRoutes />
      <Footer />

      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                name: "桔子影视",
                url: "https://juzitv.com",
                description: "桔子影视电视剧大全收录最新热播剧集高清全集资源，免费在线观看不缓冲，追剧首选平台。",
                contactPoint: {
                  "@type": "ContactPoint",
                  telephone: "400-888-6666",
                  contactType: "customer service",
                  availableLanguage: "Chinese",
                },
                address: {
                  "@type": "PostalAddress",
                  streetAddress: "朝阳区影视产业园A座15层",
                  addressLocality: "北京",
                  addressCountry: "CN",
                },
              },
              {
                "@type": "WebSite",
                name: "桔子影视",
                url: "https://juzitv.com",
                description: "桔子影视电视剧大全收录最新热播剧集高清全集资源，免费在线观看不缓冲，追剧首选平台。",
                potentialAction: {
                  "@type": "SearchAction",
                  target: "https://juzitv.com/search?q={search_term_string}",
                  "query-input": "required name=search_term_string",
                },
              },
              {
                "@type": "WebPage",
                name: location.pathname === "/" ? "桔子影视首页" : "桔子影视",
                url: `https://juzitv.com${location.pathname}`,
                isPartOf: {
                  "@type": "WebSite",
                  name: "桔子影视",
                },
              },
              {
                "@type": "BreadcrumbList",
                itemListElement: (() => {
                  const path = location.pathname;
                  const items: { "@type": string; position: number; name: string; item?: string }[] = [
                    { "@type": "ListItem", position: 1, name: "首页", item: "https://juzitv.com/" },
                  ];

                  if (path.startsWith("/category/")) {
                    items.push({ "@type": "ListItem", position: 2, name: "分类浏览", item: `https://juzitv.com${path}` });
                  } else if (path.startsWith("/drama/")) {
                    items.push({ "@type": "ListItem", position: 2, name: "剧集详情", item: `https://juzitv.com${path}` });
                  } else if (path === "/about") {
                    items.push({ "@type": "ListItem", position: 2, name: "关于我们", item: "https://juzitv.com/about" });
                  }

                  return items;
                })(),
              },
            ],
          }),
        }}
      />
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppLayout />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;